export default __webpack_public_path__ + "media/images/Masto-B1-love-7b90231ffc69a56a1df9900bd2911ad6.png";